if (!customElements.get("filters-apply")) {
  class FiltersApply extends HTMLElement {
    constructor() {
      super();
    }

    initToggle() {
      this.opener = this.querySelector(".js-opener");
      this.inner = this.querySelector(".js-inner");

      this.opener.addEventListener("click", (event) => {
        event.preventDefault();

        this.classList.toggle("is-open");
        document.body.classList.toggle("js-drawer-open");
      });

      this.querySelectorAll(".js-close").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();

          this.classList.remove("is-open");
          document.body.classList.remove("js-drawer-open");
        });
      });
    }

    connectedCallback() {
      this.initToggle();

      this.section = this.closest(".shopify-section");
      this.grid = this.section.querySelector("[data-filter-target]");

      if (!this.grid) return;

      this.addEventListener("change", (event) => {
        this.grid.updateFilter({
          type: "list",
          url: event.target.checked
            ? event.target.dataset.urlAdd
            : event.target.dataset.urlRemove,
        });
      });

      this.addEventListener("click", (event) => {
        if (event.target.tagName.toLowerCase() == "a")
          console.log("tag is <a>", event.target);
      });
    }
  }
  customElements.define("filters-apply", FiltersApply);
}
